import React from "react";
import "./index.scss";
import MailchimpSubscribe from "react-mailchimp-subscribe";
import SubscribeForm from "../SubscribeForm";

// import { notification } from "antd";

const FORM_ID = process.env.REACT_APP_FORM_ID;
const FORM_U = process.env.REACT_APP_FORM_U;
const URL = process.env.REACT_APP_FORM_URL;

const FORM_URL = `${URL}?u=${FORM_U}&id=${FORM_ID}`;

const MailchimpFormContainer = (props) => {
  const handleSubmit = (data, subscribe) => {
    console.log("data: ", data);
    subscribe(data);
  };

  return (
    <div className="mc__form-container">
      <MailchimpSubscribe
        url={FORM_URL}
        render={({ subscribe, status, message }) => {
          return (
            <SubscribeForm
              onClose={props.onClose}
              status={status}
              message={message}
              onValidated={(data) => handleSubmit(data, subscribe)}
            />
          );
        }}
      />
    </div>
  );
};

export default MailchimpFormContainer;
